import Button from './Button'
import React from 'react'
import PopupView from './forms/PopupView'


const WillModal = ({ showWantsFreePineappleWillModal, handleWillModalActions, firstName }) => (
  <PopupView
    visible={showWantsFreePineappleWillModal}
    hideCloseButton      
    width='mid-slim'  
    renderContent={() => {
      return (
        <div className='pineapple-will-popup-content'>
          <h1 className='will-popup-heading'>Free Will Unlocked!</h1>
          <div className='will-popup-content-parent'>
            <p className='will-popup-content will-popup-content--max-width-400px'>
              Congrats, {firstName ? firstName : ''} you have unlocked a <span className='will-popup-content-bolder-text'>free</span> and <span className='will-popup-content-bolder-text'>no-strings-attached</span> Pineapple Wills benefit. Yay!
            </p>
            <p className='will-popup-content will-popup-content--max-width-400px'>
              To claim this benefit, hit the "Let's do it" button so one of our friendly agents from our partner, Capital Legacy, can get in touch 🙏.
            </p>
          </div>
          <div className='will-actions-footer'>
            <Button
              title={'Naaaah!'}
              color={'dark-gray'}
              onClick={() => {
                handleWillModalActions(false)
            }}/>
            <Button
              title={'Let\'s do it!'}
              onClick={() => {
              handleWillModalActions(true)
            }}/>
          </div>
        </div>
      )
    }}
  />
  )

export default WillModal